(function () {
  function bindHeader(header) {
    var toggle = header.querySelector("[data-mlm-menu-toggle]");
    var panel = header.querySelector("[data-mlm-mobile-panel]");
    if (!toggle || !panel) return;

    toggle.addEventListener("click", function () {
      var isOpen = panel.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", String(isOpen));
      panel.hidden = !isOpen;
    });
  }

  function formatMoney(cents) {
    var amount = (Number(cents || 0) / 100).toFixed(2);
    return "$" + amount;
  }

  function cartItemImage(item) {
    if (!item.image) return "";
    var src = item.image.indexOf("//") === 0 ? "https:" + item.image : item.image;
    return '<img src="' + src + '" alt="' + (item.product_title || "Cart item") + '" loading="lazy">';
  }

  function bindCartDrawer() {
    var drawer = document.querySelector("[data-mlm-cart-drawer]");
    if (!drawer) return;

    var body = drawer.querySelector("[data-mlm-cart-body]");
    var subtotal = drawer.querySelector("[data-mlm-cart-subtotal]");
    var note = drawer.querySelector("[data-mlm-cart-note]");
    var discount = drawer.querySelector("[data-mlm-cart-discount]");
    var checkout = drawer.querySelector("[data-mlm-cart-checkout]");
    var busy = false;

    function openDrawer() {
      drawer.classList.add("is-open");
      drawer.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("mlm-cart-drawer-open");
    }

    function closeDrawer() {
      drawer.classList.remove("is-open");
      drawer.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("mlm-cart-drawer-open");
    }

    function render(cart) {
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
      document.querySelectorAll(".mlm-cart-link").forEach(function (link) {
        link.textContent = "Cart (" + cart.item_count + ")";
      });
      if (note && cart.note != null && document.activeElement !== note) {
        note.value = cart.note || "";
      }

      if (!cart.items || !cart.items.length) {
        body.innerHTML = '<div class="mlm-cart-drawer__empty"><p>Your cart is empty.</p><a class="mlm-button" href="/collections/all?view=mahjong">Shop Mahjong Sets</a></div>';
        return;
      }

      body.innerHTML = cart.items.map(function (item) {
        var options = item.variant_title && item.variant_title !== "Default Title" ? '<p class="mlm-cart-drawer-item__variant">' + item.variant_title + '</p>' : "";
        return '' +
          '<article class="mlm-cart-drawer-item" data-mlm-cart-item="' + item.key + '">' +
            '<a class="mlm-cart-drawer-item__image" href="' + item.url + '">' + cartItemImage(item) + '</a>' +
            '<div class="mlm-cart-drawer-item__main">' +
              '<div class="mlm-cart-drawer-item__top">' +
                '<a class="mlm-cart-drawer-item__title" href="' + item.url + '">' + item.product_title + '</a>' +
                '<strong class="mlm-cart-drawer-item__price">' + formatMoney(item.final_line_price) + '</strong>' +
              '</div>' +
              options +
              '<div class="mlm-cart-drawer-item__controls">' +
                '<div class="mlm-cart-drawer-qty" aria-label="Quantity">' +
                  '<button type="button" data-mlm-cart-qty="-1" aria-label="Decrease quantity">−</button>' +
                  '<span>' + item.quantity + '</span>' +
                  '<button type="button" data-mlm-cart-qty="1" aria-label="Increase quantity">+</button>' +
                '</div>' +
                '<button type="button" class="mlm-cart-drawer-item__remove" data-mlm-cart-remove>Remove</button>' +
              '</div>' +
            '</div>' +
          '</article>';
      }).join("");
    }

    function fetchCart(options) {
      return fetch("/cart.js", { credentials: "same-origin" })
        .then(function (response) { return response.json(); })
        .then(function (cart) {
          render(cart);
          if (options && options.open) openDrawer();
          return cart;
        });
    }

    function changeLine(key, quantity) {
      if (busy) return;
      busy = true;
      fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (response) { return response.json(); })
        .then(render)
        .finally(function () { busy = false; });
    }

    document.querySelectorAll("[data-mlm-cart-close]").forEach(function (button) {
      button.addEventListener("click", closeDrawer);
    });

    body.addEventListener("click", function (event) {
      var item = event.target.closest("[data-mlm-cart-item]");
      if (!item) return;
      var key = item.getAttribute("data-mlm-cart-item");
      var current = Number(item.querySelector(".mlm-cart-drawer-qty span").textContent || "1");
      var qtyButton = event.target.closest("[data-mlm-cart-qty]");
      if (qtyButton) {
        changeLine(key, Math.max(0, current + Number(qtyButton.getAttribute("data-mlm-cart-qty"))));
      }
      if (event.target.closest("[data-mlm-cart-remove]")) {
        changeLine(key, 0);
      }
    });

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener("submit", function (event) {
        var submitter = event.submitter;
        if (submitter && submitter.closest(".shopify-payment-button")) return;
        event.preventDefault();
        if (busy) return;
        busy = true;
        fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Accept": "application/json" },
          body: new FormData(form)
        })
          .then(function (response) {
            if (!response.ok) throw new Error("Unable to add item to cart.");
            return response.json();
          })
          .then(function () { return fetchCart({ open: true }); })
          .catch(function () { form.submit(); })
          .finally(function () { busy = false; });
      });
    });

    if (note) {
      note.addEventListener("change", function () {
        fetch("/cart/update.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ note: note.value })
        }).then(function (response) { return response.json(); }).then(render);
      });
    }

    if (checkout) {
      checkout.addEventListener("click", function () {
        var code = discount && discount.value ? discount.value.trim() : "";
        var go = function () {
          window.location.href = code ? "/discount/" + encodeURIComponent(code) + "?redirect=/checkout" : "/checkout";
        };
        if (note) {
          fetch("/cart/update.js", {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            body: JSON.stringify({ note: note.value })
          }).then(go).catch(go);
        } else {
          go();
        }
      });
    }

    fetchCart();
  }

  function bindHeroSlider(hero) {
    var slides = Array.prototype.slice.call(hero.querySelectorAll("[data-mlm-hero-slide]"));
    var dots = Array.prototype.slice.call(document.querySelectorAll("[data-mlm-hero-dot]"));
    var active = 0;
    var timer;

    if (slides.length < 2) return;

    function show(index) {
      active = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        slide.classList.toggle("is-active", slideIndex === active);
      });
      dots.forEach(function (dot, dotIndex) {
        dot.classList.toggle("is-active", dotIndex === active);
      });
    }

    function start() {
      window.clearInterval(timer);
      timer = window.setInterval(function () {
        show(active + 1);
      }, 5200);
    }

    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        show(Number(dot.getAttribute("data-mlm-hero-dot")) || 0);
        start();
      });
    });

    start();
  }

  document.addEventListener("DOMContentLoaded", function () {
    if (
      window.location.pathname.indexOf("/products/") === 0 &&
      window.location.search.indexOf("view=mlm") !== -1
    ) {
      var cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete("view");
      window.location.replace(cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
      return;
    }

    if (
      window.location.pathname.indexOf("/products/") === 0 &&
      window.location.search.indexOf("view=mlm") === -1 &&
      document.querySelector(".mlm-product-detail__media") &&
      !document.querySelector("[data-mlm-product-gallery]")
    ) {
      var separator = window.location.search ? "&" : "?";
      window.location.replace(window.location.pathname + window.location.search + separator + "view=mlm");
      return;
    }

    document.querySelectorAll("[data-mlm-header]").forEach(bindHeader);
    bindCartDrawer();
    document.querySelectorAll("[data-mlm-hero-slider]").forEach(bindHeroSlider);
    document.querySelectorAll(".mlm-product-detail__info .mlm-eyebrow").forEach(function (eyebrow) {
      if (eyebrow.tagName.toLowerCase() === "a") return;
      if ((eyebrow.textContent || "").trim().toLowerCase() !== "my lucky mahjong") return;
      var link = document.createElement("a");
      link.className = eyebrow.className + " mlm-product-detail__brand-link";
      link.href = "/";
      link.textContent = eyebrow.textContent;
      eyebrow.replaceWith(link);
    });

    document.querySelectorAll("[data-mlm-product-gallery]").forEach(function (gallery) {
      var slides = Array.prototype.slice.call(gallery.querySelectorAll("[data-mlm-product-slide]"));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll("[data-mlm-gallery-thumb]"));
      var prev = gallery.querySelector("[data-mlm-gallery-prev]");
      var next = gallery.querySelector("[data-mlm-gallery-next]");
      var stage = gallery.querySelector(".mlm-product-gallery__stage");
      var active = 0;
      var touchStartX = 0;

      if (!slides.length) return;

      function show(index) {
        active = (index + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle("is-active", slideIndex === active);
        });
        thumbs.forEach(function (thumb, thumbIndex) {
          thumb.classList.toggle("is-active", thumbIndex === active);
          thumb.setAttribute("aria-pressed", String(thumbIndex === active));
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          show(Number(thumb.getAttribute("data-mlm-gallery-thumb")) || 0);
        });
      });

      if (prev) prev.addEventListener("click", function () { show(active - 1); });
      if (next) next.addEventListener("click", function () { show(active + 1); });

      if (stage && slides.length > 1) {
        stage.addEventListener("touchstart", function (event) {
          touchStartX = event.touches[0].clientX;
        }, { passive: true });

        stage.addEventListener("touchend", function (event) {
          var distance = event.changedTouches[0].clientX - touchStartX;
          if (Math.abs(distance) < 40) return;
          show(distance < 0 ? active + 1 : active - 1);
        });
      }
    });

    document.querySelectorAll(".mlm-product-form__select").forEach(function (select) {
      var price = document.querySelector("[data-mlm-product-price]");
      if (!price) return;

      function syncPrice() {
        var option = select.options[select.selectedIndex];
        if (option && option.dataset.price) {
          price.textContent = option.dataset.price;
        }
      }

      select.addEventListener("change", syncPrice);
      syncPrice();
    });
  });
})();
